import { z } from "@/zod";

/**
 * - Backend always returns UTC ISO format with timezone (e.g. "2025-10-01T08:00:00+00:00").
 * - Frontend can send any valid ISO with offset (e.g. "+02:00", "Z").
 *
 * More info in AR-507 issue.
 */
export const dateTime = z.string().datetime({ offset: true }); // ISO8601 with offset
